import React, { useState } from 'react';
import portfolioData, { Project } from '../data/portfolioData';
import ProjectModal from './ProjectModal';

const ProjectsSection: React.FC = () => {
  const [selectedProject, setSelectedProject] = useState<Project | null>(null);

  return (
    <section id="projects" className="section projects">
      <div className="container">
        <h2 className="section__title">Projets</h2>
        <p className="section__subtitle">
          Une sélection de projets qui démontrent mon approche et mes compétences.
        </p>
        <div className="section__divider" />

        {/* Project Grid */}
        <div className="projects__grid">
          {portfolioData.projects.map((project) => (
            <div
              key={project.id}
              className="projects__card"
              onClick={() => setSelectedProject(project)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  setSelectedProject(project);
                }
              }}
            >
              <div className="projects__card-image">
                <img src={project.image} alt={project.name} loading="lazy" />
              </div>
              <div className="projects__card-body">
                <div className="projects__card-category">{project.category}</div>
                <h3 className="projects__card-name">{project.name}</h3>
                <p className="projects__card-tagline">{project.tagline}</p>
                <div className="projects__card-techs">
                  {project.technologies.slice(0, 4).map((tech, index) => (
                    <span key={index} className="projects__card-tech">
                      {tech}
                    </span>
                  ))}
                  {project.technologies.length > 4 && (
                    <span className="projects__card-tech">
                      +{project.technologies.length - 4}
                    </span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal */}
      {selectedProject && (
        <ProjectModal
          project={selectedProject}
          onClose={() => setSelectedProject(null)}
        />
      )}
    </section>
  );
};

export default ProjectsSection;
